import { render, staticRenderFns } from "./ProfileSettingsFormEmail.vue?vue&type=template&id=4b5cd1bc&scoped=true"
import script from "./ProfileSettingsFormEmail.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsFormEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5cd1bc",
  null
  
)

export default component.exports